import React from 'react';




const Logo:React.FC = () => {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="770 350 380 380">
      <circle className="cls-1" fill="#1d1e23" cx="960.3" cy="458.18" r="82.29"/>
      <circle className="cls-2" fill="#f9d537" cx="960.02" cy="457.9" r="53.17"/>
      <path className="cls-3" fill="#f15b5b" d="M960,540.47a82,82,0,0,0-82,82h164A82,82,0,0,0,960,540.47Z"/>
      <path className="cls-4" fill="#1583af" d="M878,622.49a82,82,0,0,0,164,0Z"/>
    </svg>
  )
};
export default Logo;